import  React, {
        useState, 
        useEffect, 
        useMemo, 
        }                                   from "react";
import  Style                               from "components/UI/main.module.scss";
import  {   getFeedBackReport,
            getCycleReportParamList
        }                                   from "./feedBackService";
import  {   GetSystemLabel,
            GetBusinessLabel,
            GetAppLang,
            Spinner,
            SpinnerSmall,
            sleep,
            isDarkMode,
            ValidateBusinessRules
        }                                   from "Utilities/utils";   
import {    getDepartmentList   }           from "../../Pages/Users/usersService";
import {    DisplayGridDatetime,
            DisplayDateAsString
       }                                    from "components/Date/date"
import { useNavigate }                      from "react-router-dom";
import { useModal }                         from "components/Covers/genericModal";
import { useSideContent }                   from "components/SideContent/sideContent";
import { ModalContent,
       }                                    from "components/Modal/modal";
import { TableGrid}                         from "components/Table/table";
import  {   RefreshBtn,
        }                                   from "components/Button/button";
import  {   SearchableDropdownList,
            DropdownListMultiple
        }                                   from "components/DropdownListField/dropdownListFIeld";
import { Pie, 
         PieChart, 
         ResponsiveContainer, 
         Tooltip,
         Cell                          }    from 'recharts';
import { getTemplateNotification       }    from "./feedback_report_template";
import { AccessDeniedContent } from "components/Content/accessContent";
const appLang = GetAppLang();

const isMobileOrTablet = () => {
    const userAgent = navigator.userAgent || window.opera;
    const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    const isSmallScreen = window.innerWidth <= 768;

    return /android|ipad|iphone|ipod/i.test(userAgent) || (isTouch && isSmallScreen);
};
const formatMessages            = ({messageHeader, messageVector}) => {
    return (
        <React.Fragment>
            <div>
                <span className={[Style.fw_semibold, Style.fs_6].join(" ")}>
                    {messageHeader}
                </span>
            </div>
            <div>
                {messageVector.map((msg, i) => (
                    <React.Fragment key={i}>
                        <div className={Style.my_3}>
                            <span className={[Style.text_body, Style.fs_8, Style.my_3,].join(" ")}>
                                {i + 1} : {msg}<br/>
                            </span>
                        </div>
                    </React.Fragment>
                ))}
            </div>
        </React.Fragment>
    );
};
const CycleControls            = React.memo(({...props}) => {
    const {CycleOperation, PeriodOperation, Cycle} = props;
    useEffect(() => {}, [Cycle]); 
    return(
        <React.Fragment>
            <div className={[Cycle.display ? Style.animation_fadein : Style.animation_fadeout].join(" ")}>
                <div className={[Style.border, Style.shadow_sm, Style.rounded_3].join(" ")}>
                    <div className={[Style.m_2, Style.d_flex, Style.align_items_center, Style.justify_content_between].join(" ")}>
                        <span className={[Style.text_body, Style.fs_8, Style.text_wrap, Style.mx_1].join(" ")}> {`${GetSystemLabel("Reference")} ${GetSystemLabel("of")} :`} {Cycle?.CycleYear}</span>
                        <div onClick={() => {CycleOperation({operation: "d", value: Cycle?.CycleId});}} className={[Style.icon, Style.clickable, Style.p_1].join(" ")}>
                            <svg viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg" className={[Style.small_ico_generic].join(" ")}>
                                <path d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"/>
                            </svg>
                        </div>
                    </div>
                    <div className={Style.pb_1}/>
                    {Cycle && Array.isArray(Cycle?.CyclePeriods) && (
                        Cycle?.CyclePeriods?.map((d) => {
                            return(
                                <React.Fragment>
                                    <div className={[Style.card_header_bg, Style.border, d.display ? Style.animation_fadein : Style.animation_fadeout].join(" ")}>
                                        <div className={[Style.m_2, Style.d_flex, Style.align_items_center, Style.justify_content_between].join(" ")}>
                                            <span className={[Style.text_body, Style.fs_8, Style.text_wrap, Style.mx_1].join(" ")}> 
                                                {`${d[`PeriodLabelName${appLang}`]}: ${DisplayDateAsString(d.StartDate, false)} ${GetSystemLabel("until")} ${DisplayDateAsString(d.EndDate, false)}`}
                                            </span>
                                            <div onClick={() => {PeriodOperation({operation: "d", value: Cycle?.CycleId, child: d?.CyclePeriodId});}} className={[Style.icon, Style.clickable, Style.p_1].join(" ")}>
                                                <svg viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg" className={[Style.small_ico_generic].join(" ")}>
                                                    <path d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"/>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            )
                        })
                    )}
                </div>  
            </div>
        </React.Fragment>
    );
});
const FilterControls           = React.memo(({...props}) => {
    const { SearchParam,
            SetSearchParam,
    }                                            = props;
    useEffect(() => {},[SearchParam, SetSearchParam]);
    
    async function handleCycleOperation(obj) {
        if (!obj) return;
        if (obj?.operation === "i") {
            SetSearchParam(prev => {
                const exists = prev.Selected.Cycles.find(d => d.CycleId === obj.value);
                if (exists) return prev;
                const cycle = prev.Default.Cycles.find(d => d.CycleId === obj.value);
                return {
                    ...prev,
                    Selected: {
                        ...prev.Selected,
                        Cycles: [
                            ...prev.Selected.Cycles, 
                            {
                                ...cycle,
                                display: true,
                                CyclePeriods: cycle.CyclePeriods.map(period => ({
                                    ...period,
                                    display: true,
                                })),
                            }
                        ]
                    }                    
                };
            });
        }
        else if (obj?.operation === "d") {
            SetSearchParam(prev => {
                const cycle = prev.Selected.Cycles.map(d => {
                    if (d.CycleId === obj.value) {
                        return {
                            ...d,
                            display: false,
                        };
                    }
                    return d;
                });
                return {
                    ...prev,
                    Selected: {
                        ...prev.Selected,
                        Cycles: cycle
                    }
                };
            });
            await sleep(800);            
            SetSearchParam(prev => {
                const filtered = prev.Selected.Cycles.filter((d) => d.CycleId !== obj.value);                
                return {
                    ...prev,
                    Selected: {
                        ...prev.Selected,
                        Cycles: [...filtered]
                    }                       
                }
            });
        }
    }
    async function handlePeriodOperation(obj) {
        SetSearchParam(prev => {
            const updated = prev.Selected.Cycles.map(d => {
                if (d.CycleId === obj.value) {
                    return {
                        ...d,
                        CyclePeriods: d.CyclePeriods.map(c => {
                            if (c.CyclePeriodId === obj.child) {
                                return {
                                    ...c,
                                    display: false,
                                };
                            }

                            return c;
                        }),
                    };
                }

                return d;
            });

            return {
                ...prev,
                Selected: {
                    ...prev.Selected,
                    Cycles: updated,
                }
            };
        });
        await sleep(800);
        SetSearchParam(prev => {
            const updated = prev.Selected.Cycles.map(d => {
                if (d.CycleId === obj.value) {
                    return {
                        ...d,
                        CyclePeriods: d.CyclePeriods.filter(
                            c => c.CyclePeriodId !== obj.child
                        ),
                    };
                }

                return d;
            });

            return {
                ...prev,
                Selected: {
                    ...prev.Selected,
                    Cycles: updated,
                }
            };
        });
    }
    async function handleDepartmentSelection(values) {
        const departments = values.map(v =>SearchParam.Default.Departments.find(d => d.DepartmentId === v.value)).filter(Boolean).map(d => ({
            ...d,
            key: d.DepartmentId,
            value: d.DepartmentId,
            label: d.DepartmentName,
        }));

        SetSearchParam(prev => ({
            ...prev,
            Selected: {
                ...prev.Selected,
                Departments: departments
            },
        }));
    }
    return (
        SearchParam?.Default?.Cycles?.length === 0  || SearchParam?.Default?.Departments?.length === 0 ?
            <SpinnerSmall/>
        :
            <React.Fragment>
                <div className={[Style.shadow_sm, Style.rounded].join(" ")}>
                    <div className={Style.row}>
                        <div className={[Style.col_lg].join(" ")}>
                            <div className={[Style.d_flex,  Style.align_items_center, Style.justify_content_between].join(" ")}>
                                <span className={[Style.text_body, Style.fs_8, Style.ms_2].join(" ")}>{GetBusinessLabel("Cycles")}</span>
                                <SearchableDropdownList    
                                    placeholder={GetBusinessLabel("Cycles")}
                                    listOfItems={
                                        SearchParam && Array.isArray(SearchParam?.Default?.Cycles)
                                        ?
                                            SearchParam?.Default?.Cycles?.map((d) => ({ value: d.CycleId, label: d.CycleYear }))
                                        : 
                                            null
                                    }
                                    style={{ width: "60%" }}  
                                    className={[Style.antd_custom_select, Style.me_2].join(" ")}                               
                                    popupClassName={Style.antd_custom_select}                              
                                    onChange={(event) => {
                                    if (event !== undefined && event !== null) {
                                        handleCycleOperation?.({
                                            operation: "i",
                                            value: event,
                                        });
                                    }
                                    }}
                                    value={undefined}
                                />
                            </div>
                            <div className={Style.py_3}/>
                            <div className={[Style.d_flex,  Style.align_items_center, Style.justify_content_between].join(" ")}>
                                <span className={[Style.text_body, Style.fs_8, Style.ms_2].join(" ")}>{GetBusinessLabel("Departments")}</span>
                                <DropdownListMultiple
                                    returnObject
                                    className={[Style.antd_custom_select, Style.me_2].join(" ")} 
                                    value={SearchParam?.Selected?.Departments}
                                    placeholder={GetBusinessLabel("Departments")}
                                    listOfItems={
                                        SearchParam && Array.isArray(SearchParam?.Default?.Departments)
                                        ? 
                                            SearchParam?.Default?.Departments.map((d) => ({ value: d.DepartmentId, label: d.DepartmentName }))
                                        : 
                                            null
                                    }
                                    style={{ width: "60%" }}
                                    onChange={(valueArray) => {handleDepartmentSelection(valueArray);}}
                                />        
                            </div>
                            <div className={Style.py_2}/>   
                            {SearchParam && Array.isArray(SearchParam?.Selected.Cycles) &&
                                SearchParam?.Selected.Cycles?.map((c) => (<CycleControls CycleOperation={handleCycleOperation} PeriodOperation={handlePeriodOperation} Cycle={c}/>))
                            }
                            <div className={Style.py_2}/>   
                        </div>
                    </div>                    
                </div>
            </React.Fragment>
    );
});
const AreaBar                  = React.memo(({...props}) => {
    const {area} = props;
    const calc = () => {
        let t = area?.completed + area?.ongoing + area?.pending;
        let avg = t > 0 ? ((area?.completed) / t)  * 100 : 0;
        avg = avg > 100 ? 100 : avg.toFixed(2); 
        return {total: t, average: avg, completed: area?.completed};
    };
    const data = calc();
    useEffect(() => {
    }, [area]);
    return(
        <div className={Style.py_2}>
            <div    style={{display: "flex", justifyContent: "space-between", alignItems: "center", gap: "0.75rem"}}>
                <span className={[Style.fs_8, Style.text_body].join(" ")}>
                    {area?.DepartmentName} 
                </span>
                <span className={[Style.fs_8, Style.text_body, Style.fw_semibold].join(" ")}>
                    {`${data?.completed} / ${data?.total} - ${data?.average}%`}
                </span>           
            </div>      
            <div className={Style.pb_1}/>
            <div    className={[Style.border_bottom, Style.border_end, Style.rounded_5].join(" ")}
                    style={{
                        width: '100%',
                        height: '10px',
                        position: 'relative',
                        overflow: 'hidden',
                        background: isDarkMode() ? "#1F2937" : "#F9FAFB" // fallback background
                    }}
            >
                <div style={{position: 'absolute', top: 0, left: 0, width: `${Math.min(data?.average, 100)}%`, height: '100%', background: isDarkMode() ? "#A78BFA" : "#6B4EFF", transition: 'width 0.3s ease', zIndex: 1}}
                    className={data?.average}
                />
            </div>
        </div>
    );
});
const DashboardArea            = React.memo(({...props}) => {
    const { Data,  }                = props;
    const [ half,   setHalf ]       = useState({first: [], second: []});

    const itemLength =  Data?.departments?.length;

    useEffect(() => {
        if ( itemLength > 0 ) {
            const middle = Math.ceil(itemLength / 2);
            setHalf(prev => {
                return({
                    ...prev,
                    first: Data.departments.slice(0, middle),
                    second: Data.departments.slice(middle),
                })
            });
        }
    }, [Data]);

    return(
        itemLength > 0 && (
            <React.Fragment>
                <div className={[Style.mb_3, Style.mx_1].join(" ")}>
                    <span className={[Style.fs_8, Style.text_body, Style.fw_semibold].join(" ")}>
                        {GetBusinessLabel("ReportPageLabel0")}
                    </span>
                </div>
                <div className={Style.row}>
                    <div className={Style.col_lg}>
                        <div className={Style.mx_2}>
                            {
                                half?.first?.length > 0 ? (
                                    half?.first?.map((entry, index) => (
                                        <AreaBar key={index} area={entry}/>
                                    ))
                                )
                                :
                                null
                            }
                        </div>
                    </div>
                    <div className={Style.col_lg}>
                        <div className={Style.mx_2}>
                            {
                                half?.second?.length > 0 ? (
                                    half?.second?.map((entry, index) => (
                                        <AreaBar key={index} area={entry}/>
                                    ))
                                )
                                :
                                null
                            }
                        </div>
                    </div>                
                </div>
            </React.Fragment>
        )
    );
})
const DashboardConclusion      = React.memo(({...props}) => {
    const { row, 
            dashData,  
            setDashData, 
            vector, 
            setVector 
        }                                         = props;
    const departmentSample  = {
        DepartmentId: 0,
        DepartmentName: "",
        completed:  0, 
        ongoing:    0, 
        pending:    0,
    };
    const countedData = () => {
        if (!row || row.length === 0) {
            setDashData(null);
            setVector([]);
            return;
        }        
        let obj = {   
            total:      0, 
            completed:  0, 
            ongoing:    0, 
            pending:    0,
            departments: []
        };
        let captured = false;
        for (let i = 0; i < row?.length; i++) {
            captured = false;
            for (let k = 0; k < obj?.departments?.length; k++) {                
                if (row[i].DepartmentId === obj?.departments[k].DepartmentId) {
                    if (row[i].FillStatusId === 1) {
                        obj.completed++;
                        obj.departments[k].completed++;
                    }
                    if (row[i].FillStatusId === 0 && row[i].StatusId === 1) {
                        obj.ongoing++;
                        obj.departments[k].ongoing++;
                    }
                    if (row[i].FillStatusId == null || row[i].StatusId == null) {
                        obj.pending++;
                        obj.departments[k].pending++;
                    }
                    obj.total++;
                    captured = true;
                    break;
                }
            }
            if(!captured) {
                obj.departments.push({...departmentSample,
                    DepartmentId: row[i].DepartmentId,
                    DepartmentName: row[i].DepartmentName,
                    completed:  (row[i].FillStatusId === 1)? 1 : 0,
                    ongoing:    (row[i].FillStatusId === 0 && row[i].StatusId === 1) ? 1 : 0,
                    pending:    (row[i].FillStatusId === null || row[i].StatusId === null  || row[i].FillStatusId === undefined || row[i].StatusId === undefined) ? 1 : 0,
                });    
                if (row[i].FillStatusId === 1) {
                    obj.completed++;
                }
                if (row[i].FillStatusId === 0 && row[i].StatusId === 1) {
                    obj.ongoing++;
                }
                if (row[i].FillStatusId == null || row[i].StatusId == null) {
                    obj.pending++;
                }               
                obj.total++;             
            }
        }
        setDashData(obj);     
        chartData(obj);
    };
    const chartData = (data) => {

        const chart = [
            {
                name:  GetSystemLabel("Finished"),
                value: data.completed,
                color: isDarkMode() ? "rgb(74, 222, 128)": "rgb(46, 125, 50)",
            },
            {
                name:  GetSystemLabel("InProgress"),
                value: data.ongoing,
                color: isDarkMode() ? "rgb(103, 212, 255)": "rgb(2, 173, 225)",                
            },
            {
                name:  GetSystemLabel("Pending"),
                value: data.pending,
                color: isDarkMode() ? "rgb(252, 211, 77)": "rgb(245, 158, 11)",
            },
        ];

        setVector(chart);
    }; 
    const renderLabel = ({cx,cy,midAngle,outerRadius,percent,name,}) => {
        const RADIAN = Math.PI / 180;
        const radius = outerRadius + 18;

        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);

        return (
            <text
                x={x}
                y={y}
                fill={isDarkMode() ? "#fff" : "#333"}
                textAnchor={x > cx ? "start" : "end"}
                dominantBaseline="central"
                fontSize={9}
            >
                {`${name} (${(percent * 100).toFixed(0)}%)`}
            </text>
        );
    };

    useEffect(() => {
        if (!row || row.length === 0) {
            setVector([]);
            setDashData(null);
            return;
        }

        countedData();
    }, [row]);

    return(
        vector?.length > 0 ? (
            <ResponsiveContainer width={!isMobileOrTablet() ? "100%" : "100%"} height={!isMobileOrTablet() ? 300 : 300}>
                <PieChart>
                    <Pie
                        data={vector}
                        dataKey="value"
                        nameKey="name"
                        isAnimationActive={true}
                        cx="50%"
                        cy="50%"
                        outerRadius={!isMobileOrTablet() ? 80 : 80}
                        label={renderLabel}
                        labelLine={false}
                    >
                        {vector?.map((entry, index) => (
                            <Cell
                                key={`cell-${index}`}
                                fill={entry.color}
                            />
                        ))}
                    </Pie>
                    <Tooltip />
                </PieChart>
            </ResponsiveContainer>
        )
        :
        null
    );
})
const FeedBackReport           = React.memo(({...props}) => {
    const { IsLoading,
            SetIsLoading,
            RowData,
            SearchText,
            SetSearchText,
            Content,
            SetContent,
            ShowModal,
            HideModal,
            ShowSideContent,
            HideSideContent,
            GetList,
            SearchParam,
            SetSearchParam,
    }                                            = props;
    // Mount State    
    const [isReady, setIsReady]                  = useState(false);
    const [dashData, setDashData ]                = useState(
        {   
            total:      0, 
            completed:  0, 
            ongoing:    0, 
            pending:    0,
            departments: []
        }
    );
    const [vector, setVector]                     = useState([]);    

    function isValidCycle(d) {
        return ((d?.CycleYear !== null  && d?.CycleYear !== undefined) && 
                (d?.StartDate !== null  && d?.StartDate !== undefined) && 
                (d?.EndDate !== null    && d?.EndDate !== undefined)) ? true : false;
    }
    const EmailButton               = (data) => {
        let emails = [];
        if (data?.MentorsEmail) {
            let pstack = data?.MentorsEmail.split("|o|");
            let stackLen = pstack.length;
            let istack   = [];
            let fullName = "";
            let email    = "";
            for(let i = 0; i < stackLen; i++) {
                istack   = pstack[i].split("|p|");
                fullName = istack[0]?.trim();
                email    = istack[1]?.trim();
                if (email) {
                    emails.push(fullName ? `${fullName} <${email}>` : email);
                }
            }
        }
        const handleClick = () => {
            const to = emails.join(",");
            const subject = `${GetBusinessLabel("ReportPageLabel2")}: ${data?.FirstName || ""} ${data?.LastName || ""}`;
            const body = getTemplateNotification(data); 
            const mailtoLink = `mailto:${encodeURIComponent(to)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
            window.location.href = mailtoLink;
        };        
        return (
            data?.FillStatusId === 1 ?
                null
            :
                (<div onClick={handleClick} className={[Style.d_flex, Style.align_items_center, Style.justify_content_center, Style.my_1].join(" ")}>
                    <div className={[Style.vanilla_bg, Style.rounded_3, Style.text_center, Style.clickable].join(" ")}>
                        <span className={[Style.text_body, Style.fs_8, Style.m_2].join(" ")}>                    
                            {GetSystemLabel("Notify")}
                        </span>
                    </div>
                </div>)
        );
    }  
    const MenteeMeta                = (data) => {
        return (`${data?.FirstName} ${data?.LastName} (${data?.Email})`);
    };  
    const CycleMeta                 = (data) => {
        return (
            isValidCycle(data) ?
                <span>                    
                    {`${data?.CycleYear}: ${data?.[`PeriodLabelName${GetAppLang()}`]} (${DisplayGridDatetime({value: data?.StartDate})} ${GetSystemLabel("until")} ${DisplayGridDatetime({value: data?.EndDate})})`} 
                </span>
            :
                <span>                    
                    {GetBusinessLabel("TableStateNotStarted")}
                </span>
        );
    };  
    const StatusFeedback            = (data) => {
        return(
            isValidCycle(data)?
                    (data?.StatusId !== null) ? (
                        (data?.FillStatusId === 0)  ? 
                            <span className={[Style.text_info, Style.fw_semibold].join(" ")}>                    
                                {GetSystemLabel("Open")}
                            </span>
                        :
                        (data?.FillStatusId === 1)  ? 
                            <span className={[Style.text_success, Style.fw_semibold].join(" ")}>                    
                                {GetSystemLabel("Finished")}
                            </span>
                        :
                            <span className={[Style.text_warning, Style.fw_semibold].join(" ")}>                    
                                {GetSystemLabel("Pending")}
                            </span>
                    )
                    :
                    <span className={[Style.text_warning, Style.fw_semibold].join(" ")}>                    
                        {GetSystemLabel("Pending")}
                    </span>
            :
                <span className={[Style.text_warning, Style.fw_semibold].join(" ")}>                    
                    {GetSystemLabel("Pending")}
                </span>
        );
    };   
    const handleSearch              = async () => {
        let messages = [];
        if (SearchParam?.Selected?.Cycles?.length === 0  || SearchParam?.Selected?.Cycles === null || SearchParam?.Selected?.Cycles === undefined) {
            messages.push(GetBusinessLabel("ReportPageLabel1"));
        }
        if (messages.length > 0) {
            ShowModal(<ModalContent Message={formatMessages({messageHeader: GetSystemLabel("Attention"), messageVector: messages})}/>);
        }
        else {
            await GetList({...SearchParam.Selected});
        }
    };

    const columnDefs                = useMemo(() => [  
		{ 
            hide: false,lockVisible: true,
			headerName: GetBusinessLabel("Contributor"),
            valueGetter: (params) => MenteeMeta(params.data),
			cellRenderer: (params) => (MenteeMeta(params?.data)),
			width: 350, 
			filter: true, 
			flex: 0, 
			cellClass: [Style.table_text_left].join(" ")
		},
        {
            headerName: GetSystemLabel("Reference"),
            marryChildren: true,
            children: [                     
                { 
                    hide: false,lockVisible: true,
                    headerName: GetBusinessLabel("DevelopmentStageFeedback"),
                    field: `DevelopmentStageName${appLang}`,
                    filter: true , 
                    flex: 0, 
                    cellClass: [Style.table_text_left].join(" ")
                },            
                { 
                    hide: false,lockVisible: true,
                    headerName: GetBusinessLabel("DepartmentCurrent"),
                    field: "DepartmentName",
                    filter: true , 
                    flex: 0, 
                    cellClass: [Style.table_text_left].join(" ")
                },     
                { 
                    hide: false,lockVisible: true, columnGroupShow: 'open',
                    headerName: GetBusinessLabel("DepartmentOld"),
                    field: "CycleDepartmentName",
                    filter: true , 
                    flex: 0, 
                    cellClass: [Style.table_text_left].join(" ")
                },                
                { 
                    hide: false,lockVisible: true, columnGroupShow: 'open',
                    headerName: GetBusinessLabel("AssignmentCurrent"),
                    field: `AssignmentName${appLang}`,
                    filter: true , 
                    flex: 0, 
                    cellClass: [Style.table_text_left].join(" ")
                },
                { 
                    hide: false,lockVisible: true, columnGroupShow: 'open',
                    headerName: GetBusinessLabel("AssignmentOld"),
                    field: `CycleAssignmentName${appLang}`,
                    filter: true , 
                    flex: 0, 
                    cellClass: [Style.table_text_left].join(" ")
                },                                                        
            ]
        },          		
        { 
            hide: false,lockVisible: true,
            headerName: GetBusinessLabel("FilledIn"),                 
            cellRenderer: (params) => (StatusFeedback(params?.data)),
            wrapText: true,
            autoHeight: true,
            flex: 0, 
            cellClass: [Style.table_text_left].join(" ")
        },      
        { 
            hide: false,lockVisible: true,
            headerName: GetSystemLabel("Notify"),                 
            cellRenderer: (params) => (EmailButton(params?.data)),
            width: 100,
            wrapText: true,
            autoHeight: true,
            cellStyle: { whiteSpace: "pre-line" },
        }, 
        {
            headerName: GetBusinessLabel("Mentors"),
            marryChildren: true,
            children: [
                { 
                    hide: false,lockVisible: true,
                    columnGroupShow: 'open', 
                    headerName: GetBusinessLabel("Mentors"),          
                    field: "MentorMetaData",
                    width: 400,
                    wrapText: true,
                    autoHeight: true,
                    cellStyle: { whiteSpace: "pre-line" },
                    filter: true , 
                    flex: 0,
                },                             
            ]
        },                               
		{   hide: false,lockVisible: true,
			headerName: GetSystemLabel("Reference"),
			cellRenderer: (params) => (CycleMeta(params?.data)),
			filter: true, 
			flex: 0, 
			cellClass: [Style.table_text_left].join(" ")
		},
        {   hide: false,lockVisible: true, 
			headerName: GetBusinessLabel("Hiring"),
			cellRenderer: DisplayGridDatetime,
			field: "HiredDate",
			filter: true , 
			flex: 0, 
			cellClass: [Style.table_text_left].join(" ")
		},
        {
            headerName: GetSystemLabel("Tracking"),
            marryChildren: true,
            children: [
				{ hide: false,lockVisible: true, columnGroupShow: 'open',                  headerName: GetSystemLabel("Identifier"),			   field: "UserId"         			   ,filter: true , flex: 0, width: 130, cellClass: [Style.table_text_center].join(" ")}    ,				
                { hide: false,lockVisible: true, columnGroupShow: 'open',                  headerName: GetBusinessLabel("Department"),            field: "CycleDepartmentId"          ,filter: true , flex: 0, width: 130, cellClass: [Style.table_text_center].join(" ")}    ,				
                { hide: false,lockVisible: true, columnGroupShow: 'open',                  headerName: GetBusinessLabel("DepartmentCurrent"),     field: "DepartmentId"          ,filter: true , flex: 0, width: 130, cellClass: [Style.table_text_center].join(" ")}    ,				                
				{ hide: false,lockVisible: true, columnGroupShow: 'open',                  headerName: GetBusinessLabel("Cycle"),			   	   field: "CycleId"         		   ,filter: true , flex: 0, width: 130, cellClass: [Style.table_text_center].join(" ")}    ,								
				{ hide: false,lockVisible: true, columnGroupShow: 'open',                  headerName: GetBusinessLabel("Period"),			   	   field: "CyclePeriodId"         	   ,filter: true , flex: 0, width: 130, cellClass: [Style.table_text_center].join(" ")}    ,												
                { hide: false,lockVisible: true, columnGroupShow: 'open',                  headerName: GetSystemLabel("CreatedDate"),             cellRenderer: DisplayGridDatetime, field: "CreatedDate"                 ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,
                { hide: false,lockVisible: true,											headerName: GetSystemLabel("UpdatedDate"),        	   cellRenderer: DisplayGridDatetime, field: "UpdatedDate"                 ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,
            ]
        },        
    ].filter(Boolean), [RowData]);
    
    const gridContext               = useMemo(() => ({
        IsLoading,
        RowData,
        SetIsLoading,
    }), [RowData]);

    useEffect(() => {
        if (!isReady) {
            setIsReady(true);
            SetIsLoading(false);
        }
    }, [Content, isReady, SearchParam]);

    return (
        <div className={Style.my_2}>
            <div className={[Style.row].join(" ")}>
                <div className={[Style.col_lg, Style.d_flex, Style.align_items_center, Style.justify_content_start].join(" ")}>
                    <p className={[Style.fs_6, Style.text_body, Style.fw_semibold, Style.me_2].join(" ")}>                    
                        {GetBusinessLabel("ReportPageHeader_0")}
                    </p>
                    <RefreshBtn
                        Label={{text: GetSystemLabel("Update"), style: [Style.text_body, Style.fs_8, Style.mx_1].join(" ")}}
                        Button={{
                            class:      [   Style.d_flex,
                                            Style.align_items_center,
                                            Style.justify_content_center,
                                            Style.clickable,  
                                            Style.rounded_3, 
                                            Style.border, 
                                            Style.shadow_sm, 
                                            Style.vanilla_bg, 
                                            Style.text_center, 
                                            Style.pop_item_animation,
                                        ].join(" "),
                            style:      {}
                        }}
                        Action={async () => {await handleSearch();}} 
                    />
                </div>
            </div>
            {IsLoading? 
                <React.Fragment>
                    <div className={Style.overflow_hidden}>
                        <div className={Style.py_5}>
                            <Spinner/>
                        </div>
                    </div>
                </React.Fragment>
            :
                <React.Fragment>
                    <div className={[Style.row, Style.card_bg, Style.shadow_sm, Style.border, Style.rounded].join(" ")}>
                        <div className={Style.col_lg_3}>
                            <div className={[Style.py_3].join(" ")}>
                                <DashboardConclusion row={RowData} dashData={dashData} setDashData={setDashData} vector={vector} setVector={setVector}/>
                                <FilterControls SearchParam={SearchParam} SetSearchParam={SetSearchParam}/>
                            </div>
                        </div>
                        <div className={Style.col_lg_9}>
                            <div className={Style.py_3}>
                                <DashboardArea Data={dashData}/>
                                <TableGrid
                                    columnDefs={columnDefs}
                                    rowData={RowData}
                                    searchText={SearchText}
                                    setSearchText={SetSearchText}
                                    gridContext={gridContext}
                                />
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            }
        </div>
    );
});


export const FeedBackReportPage       = () => {
    const [ mount,          setMount                ]       = useState(false);
    const { showSideContent, hideSideContent        }       = useSideContent();    
    const { showModal, hideModal                    }       = useModal();
    const [isLoading,   setIsLoading]                       = useState(true);
    const [rowData,     setRowData]                         = useState([]);      // State of rows def 
    const [searchText,  setSearchText]                      = useState('');      // Searched text state    
    const [content,     setContent]                         = useState({type: 1, last: 1, header: null, body: null});
    const [searchParam, setSearchParam]                     = useState({Default: { Cycles: [], Departments: []}, Selected: {Cycles: [], Departments: []}});
    const [ access,     setAccess                   ]       = useState(false);    
    
    const fetchCycleParamList           = async () => {
        try {
            let payload = await getCycleReportParamList();
            if (payload) {
                if (payload?.Status?.Code === 0) {
                    setSearchParam(prev => ({
                        ...prev,
                        Default: {
                            ...prev.Default,
                            Cycles: [...payload.Response.Content]
                        }                        
                    }));
                }
                else {
                    showModal(<ModalContent Message={payload.Status.Message}/>);
                }                        
            }
            else {
                showModal(<ModalContent Message={GetSystemLabel("ErrorGeneric")}/>);
            }
        }
        catch (error) {
            console.error(error);
        }
    };
    const fetchDepartmentParamList      = async () => {
        try {
            let payload = await getDepartmentList({StatusIds: [1,2,3]});
            if (payload) {
                if (payload?.Status?.Code === 0) {
                    setSearchParam(prev => ({
                        ...prev,
                        Default: {
                            ...prev.Default,
                            Departments: [...payload.Response.Content]
                        }                        
                    }));
                }
                else {
                    showModal(<ModalContent Message={payload.Status.Message}/>);
                }                        
            }
            else {
                showModal(<ModalContent Message={GetSystemLabel("ErrorGeneric")}/>);
            }
        }
        catch (error) {
            console.error(error);
        }
    };
    const fetchFeedBackList             = async (obj) => {
        try {
            let payload = await getFeedBackReport(obj);
            if (payload) {
                if (payload.Status.Code === 0) {
                    setRowData(payload.Response.Content);
                }
                else {
                    showModal(<ModalContent Message={payload.Status.Message}/>);
                }                        
            }
            else {
                showModal(<ModalContent Message={GetSystemLabel("ErrorGeneric")}/>);
            }
        }
        catch (error) {
            console.error(error);
        }
    };
    
    useEffect(() => {
        if(!mount) {
            if(ValidateBusinessRules("B")) {
                setAccess(true);
                fetchCycleParamList();
                fetchDepartmentParamList();
            }
            setMount(true);
        }
    }, [content]);

    return (
        access ?
            <div className={[Style.m_2, Style.pb_5].join(" ")}>
            <React.Fragment>
            {
                content?.type === 1? 
                    <React.Fragment>
                        <FeedBackReport 
                            ShowSideContent={showSideContent}
                            HideSideContent={hideSideContent}
                            ShowModal={showModal}
                            HideModal={hideModal}
                            IsLoading={isLoading}
                            SetIsLoading={setIsLoading}
                            RowData={rowData}
                            SetRowData={setRowData}
                            SearchText={searchText}
                            SetSearchText={setSearchText}
                            Content={content}
                            SetContent={setContent}
                            GetList={fetchFeedBackList}
                            SearchParam={searchParam}
                            SetSearchParam={setSearchParam}
                        />
                    </React.Fragment>
                :                  
                    null
            }
            </React.Fragment>
                <div className={Style.py_2}/>
            </div>
        :
            <AccessDeniedContent/>
    );
};  